import { request } from "shared/api/request"

export interface PresignedUrlData {
  url: string
  fields: Record<string, string>
}

export async function uploadToPresignedUrl(
  presignedUrl: PresignedUrlData,
  file: File
): Promise<void> {
  const formData = new FormData()
  // eslint-disable-next-line no-restricted-syntax
  for (const [key, value] of Object.entries(presignedUrl.fields)) {
    formData.append(key, value)
  }
  formData.append("file", file)

  const result = await request(presignedUrl.url, {
    method: "POST",
    body: formData
  }).catch(() => null)

  if (!result?.ok) throw new Error("S3 upload failed")
}
